export enum ScrollIntoViewIds {
  Recommendations = 'productRecommendations',
}
